<template>
  <view 
    :class="{
      'page-container': true,
    }" 
    :data-current-url="$nowCurrentServer.value" 
    data-index="1"
  >
    <NuxtLayout>
      <PageRender v-if="!$isErpBuySite.value" :activeDetailData="activeDetailData" @contextmenu="onContextmenu"
        :edit="edit" :currentElementIndex="currentElementIndex" :currentElementIndexStr="currentElementIndexStr" />
      <ErpBuyIndexDefault v-if="$isErpBuySite.value" />
    </NuxtLayout>
  </view>
</template>

<script setup>
import { ref, computed, onMounted, watch, provide } from "vue";
import PageRender from "~/components/render/PageRender.vue";
import ErpBuyIndexDefault from "~/components/common/ErpBuyIndexDefault.vue";
import { get, find, findIndex } from "lodash-es";
import pageEditorUse, {
  getActiveDetailDataAsync
} from "~/composables/pageEditorUse";
import { useRoute, useState, useNuxtApp } from "#app";

const { $isErpBuySite, $getNowCurrentPageConfig, $nowCurrentServer } = useNuxtApp()

import { setToken, setIsErpBuyMode, isErpBuyMode } from "@/utils/globalData";

const headers = useRequestHeaders();
const route = useRoute();
const currentPageIndex = ref(0);


let pageUrl = 'pc'
try {
  const mallPageConfig = get($getNowCurrentPageConfig, 'value.mallPageConfig', []);
  const mallPageConfigIndex = find(mallPageConfig, (o) => o.pageKey == 'index') || {};
  if (mallPageConfigIndex && mallPageConfigIndex.match && $nowCurrentServer.value) {
    let isMatch = findIndex(mallPageConfigIndex.match, (url) => url.indexOf($nowCurrentServer.value) >= 0) > -1;
    if (isMatch && mallPageConfigIndex.pageUrl) {
      pageUrl = mallPageConfigIndex.pageUrl;
    }
  }
} catch (e) {
  console.log(e);
}
const { data: activeDetailData } = await useAsyncData(
  "activeDetail",
  getActiveDetailDataAsync.bind(this, { headers, $fetch, url: pageUrl }, { currentPageIndex }),
  {
    watch: [route]
  }
);
let {
  onContextmenu,
  edit,
  currentElementIndex,
  currentElementIndexStr,
  getConfigJsonHook
} = pageEditorUse({
  activeDetailData,
  currentPageIndex
}, {
  isPage: true
});
// 提供函数给子组件使用
provide("getConfigJson", getConfigJsonHook);
</script>

<style scoped></style>